module.exports = __webpack_public_path__ + "static/media/logo_black.821fa466.svg";